import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import AnchorLink from '../../components/AnchorLink';
import { usePromoClickEvent } from '../../hooks/use-promo-click-event';
import { getImageAltTextAndUrl } from '../../analytics/get-image-alt-text-and-url';
import { IMAGE_NAME } from '../../constants/analyticsNames';
import styles from '../../components/Image/index.module.scss';
function ImageLink({ analytics, children, className, componentId, linkURL, newWindow, position }) {
    const promoClickEvent = usePromoClickEvent();
    if (!linkURL)
        return children;
    const target = newWindow ? '_blank' : '_self';
    return (React.createElement(AnchorLink, { className: classnames(styles.link, {
            [className]: !!className,
        }), onClick: event => {
            const { imageUrl, altText } = getImageAltTextAndUrl(event);
            promoClickEvent(Object.assign(Object.assign({}, analytics), { altText, creative: IMAGE_NAME, id: componentId, imageUrl, linkUrl: linkURL, name: analytics.promoName, position,
                target }));
        }, target: target, href: linkURL }, children));
}
ImageLink.defaultProps = {
    analytics: {},
    children: undefined,
    className: undefined,
    linkURL: undefined,
    position: undefined,
    newWindow: undefined,
};
ImageLink.propTypes = {
    analytics: propTypes.shape({
        analyticsId: propTypes.string,
        promoName: propTypes.string,
    }),
    children: propTypes.node,
    className: propTypes.string,
    componentId: propTypes.string.isRequired,
    linkURL: propTypes.string,
    position: propTypes.string,
    newWindow: propTypes.bool,
};
export default ImageLink;
//# sourceMappingURL=ImageLink.js.map